import { CircularProgress } from '@material-ui/core';
import React from 'react';

export const EvaluationSpinner: React.FC = () => {
  return (
    <>
      <CircularProgress size={30} style={{ verticalAlign: 'middle', marginRight: '10px', color: 'black' }} />
      <span style={{ fontSize: '16px' }}>Weryfikacja oceny w toku...</span>
    </>
  );
};
